var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashbord"},[_c('header',{staticClass:"haeder menu-header"},[_c('nav-componment')],1),_c('main',{staticClass:"main",class:{ 'no-background': _vm.isViewMode2 }},[_c('router-view')],1),(_vm.isHome)?_c('footer',{staticClass:"footer menu-footer"},[_c('footer-component')],1):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }